import { IconHeadset } from "@repo/ui/icons";
import { DiagramSlide, type StepDef } from "./DiagramSlide";
import type { NodeDef } from "@components/architecture-data";

const ONCALL_NODE: NodeDef = {
  id: "oncall",
  color: "teal",
  icon: IconHeadset,
  label: "On Call",
  desc: "",
  x: 1540,
  y: 248,
  layers: ["all"],
};

const STEPS: StepDef[] = [
  {
    key: "trigger",
    label: "Trigger",
    nodes: new Set(["alerts", "servicedesk", "slack", "rootly"]),
    arrows: [
      { from: "alerts", to: "rootly", color: "#4ade80" },
      { from: "servicedesk", to: "rootly", color: "#fb923c" },
      { from: "slack", to: "rootly", color: "#22d3ee" },
    ],
    caption:
      "Incident created manually or via configured alert",
  },
  {
    key: "respond",
    label: "Respond",
    nodes: new Set(["rootly", "slack", "oncall"]),
    arrows: [
      { from: "rootly", to: "slack", color: "#4ade80" },
      { from: "rootly", to: "oncall", color: "#22d3ee" },
    ],
    caption:
      "Incident routed to appropriate on-call staff",
  },
];

export function IncidentManagementSlide() {
  return (
    <DiagramSlide
      title="Incident Management"
      subtitle="Automated incident detection, routing, and response coordination"
      steps={STEPS}
      extraNodes={[ONCALL_NODE]}
    />
  );
}
